import { PLATFORM } from 'aurelia-pal';
/**
 * The definition of all the routes of the app.
 * @type {AppNavigation}
 */
export const NAVIGATION = {
  avatar: [
    {
      name: 'logout',
      route: ['logout'],
      moduleId: PLATFORM.moduleName('aurelio/containers/logout/logout.container'),
      title: 'Logout',
      settings: {
        hideMenu: true,
      },
    },
  ],
  main: [],
  sub: [],
  unmapped: [
    {
      name: 'home',
      route: ['', 'product-feeds/:accountId?/:option?/:itemId?/:subOption?'],
      moduleId: PLATFORM.moduleName(
        'modules/productFeeds/containers/productFeeds/productFeeds.container',
      ),
      title: 'Product Feeds',
    },
    {
      name: 'productFeeds',
      route: ['product-feeds/:accountId?/:option?/:itemId?/:subOption?'],
      moduleId: PLATFORM.moduleName(
        'modules/productFeeds/containers/productFeeds/productFeeds.container',
      ),
      title: 'Product Feeds',
    },
    {
      name: 'login',
      route: ['login'],
      moduleId: PLATFORM.moduleName('aurelio/containers/login/login.container'),
      title: 'Login',
      settings: {
        hideMenu: true,
        requiresAuthorization: false,
      },
    },
  ],
};
